export const languages = ["en", "ru", "es", "ge"] as const;

export type LanguageKeys = (typeof languages)[number];

export const LANGUAGE_STORAGE_KEY = "language";

export const DEFAULT_LANGUAGE = languages[0];
